/**
 * How human players are grouped and opposed for a map or match session.
 * Wire values are stable for analytics (`SP`, `MP-COOP`, `MP-PVP`).
 */
export enum PlayerGrouping {
  SP = 'SP',
  MP_COOP = 'MP-COOP',
  MP_PVP = 'MP-PVP'
}
